import { createBreadcrumbAPI, createBreadcrumbedEventChannel } from '../events/breadcrumbs';
import { createCatchingEventChannel } from '../events/core';
var breadcrumbAPI = createBreadcrumbAPI();
var breadcrumbMountedEventChannel = breadcrumbAPI.breadcrumbMountedEventChannel,
  Breadcrumb = breadcrumbAPI.Breadcrumb,
  useGetBreadcrumbs = breadcrumbAPI.useGetBreadcrumbs;
export { breadcrumbMountedEventChannel, Breadcrumb, useGetBreadcrumbs };
export var externalGasV3UIEventChannel = createCatchingEventChannel();
export var externalGasV3ScreenEventChannel = createCatchingEventChannel();
export var externalGasV3TrackEventChannel = createCatchingEventChannel();
export var externalGasV3OperationalEventChannel = createCatchingEventChannel();
export var externalSentryExceptionChannel = createCatchingEventChannel();
export var internalGasV3UIEventChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export var internalGasV3ScreenEventChannel = createCatchingEventChannel();
export var internalGasV3TrackEventChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export var internalGasV3OperationalEventChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);
export var internalSentryExceptionChannel = createBreadcrumbedEventChannel(breadcrumbAPI, createCatchingEventChannel);